import { handleMutationResult } from '@/helpers/toastHelper';
import { usePublishRosterMutation } from '@/services/gql/graphql.generated';
import { strings } from '@/services/translation/strings';
import { useCallback, useState } from 'react';
import { OperationResult } from 'urql';
import { useRefreshRosters } from '../providers/RosterOptionsService';
import { useWorkingRoster, useWorkingRosterService } from '../providers/WorkingRosterService';

export const usePublishWorkingRoster = () => {
  const [{ error }, publish] = usePublishRosterMutation();
  const updateWorkingRoster = useWorkingRosterService(state => state.publishWorkingRoster);
  const { workingRoster } = useWorkingRoster();
  const refreshRosters = useRefreshRosters();

  // The GQL mutation should provide a fetching state for us, but for some reason, it doesn't
  // get cleared properly with this endpoint? Need to create our own version.
  const [fetching, setFetching] = useState<boolean>(false);

  const publishRoster = useCallback(async () => {
    if (!workingRoster) {
      throw Error('Working roster should be defined');
    }
    setFetching(true);

    const result = await publish({
      rosterId: workingRoster?.id
    });

    await handleMutationResult(result, {
      successMessage: strings.daily.roster.publishedSuccessMessage,
      errorMessage: strings.daily.roster.publishedFailureMessage,
      onSuccess: () => {
        updateWorkingRoster();
        refreshRosters();
      }
    });

    setFetching(false);

    return result;
  }, [publish, updateWorkingRoster, refreshRosters]);

  return { publishRoster, error, fetching };
};
